/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import Select from "react-select";
import i18n from "i18next";
import Helpers from "util/helpers";
import requireAuth from "components/hoc/requireAuth";
import { getInformationalVideos, getVideoCategories } from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import InformationalVideos from "./InformationalVideos";
import toastr from "toastr";

class InformationalVideosContainer extends Component {
  state = {
    dataFetched: false,
    selectedServiceType: null,
    selectedVideoCategory: null,
    videoCategoryOptions: [],
  };

  componentDidMount() {
    this.fetchData();
    this.fetchVideoCategoryOptions();
  }

  componentDidUpdate(prevProps, prevState) { }

  fetchData = () => {
    this.props.getInformationalVideos(
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    toastr.error(err.response.data.message);
    this.props.onProcessEnd();
  };

  onSuccess = () => {
    this.props.onProcessEnd();
    this.setState({
      dataFetched: true,
    });
  };

  fetchVideoCategoryOptions = () => {
    this.props.getVideoCategories(
      () => {
        console.log("getVideoCategories begin");
      },
      (res) => {
        console.log("getVideoCategories success");

        const options = [];
        options.push({ value: "0", label: i18n.t("10614") });

        const langCode = Helpers.getLangCode(
          localStorage.getItem("i18nextLng")
        );

        res.data.data.videoCategories.forEach((e) => {
          let label = e.name;
          if (
            e.videoCategoryLanguages !== null &&
            e.videoCategoryLanguages.length > 0
          ) {
            let exist = e.videoCategoryLanguages.find(
              (z) => z.languageCode === langCode
            );
            if (exist) label = exist.name;
          }

          options.push({ value: e.id, label: label });
        });

        this.setState({ videoCategoryOptions: options });
      },
      (err) => {
        console.log(err);
      }
    );
  };

  handleServiceTypeSelect = (e) => {
    this.setState({ selectedServiceType: e.value });
  };

  renderServiceTypeCombo = () => {
    /*
      Satış = 15;
      Satış Sonrası = 10
      Ortak = 20
    */

    const options = [
      { value: "0", label: i18n.t("10614") },
      { value: "15", label: i18n.t("10611") },
      { value: "10", label: i18n.t("10612") },
      { value: "20", label: i18n.t("10613") },
    ];

    return (
      <Select
        placeholder={i18n.t("10521")}
        options={options}
        onChange={(e) => this.handleServiceTypeSelect(e)}
        value={options.find(
          (o) => o.value === String(this.state.selectedServiceType)
        )}
      />
    );
  };

  handleVideoCategorySelect = (e) => {
    this.setState({ selectedVideoCategory: e.value });
  };

  renderVideoCategoryCombo = () => {
    return (
      <Select
        placeholder={i18n.t("10521")}
        options={this.state.videoCategoryOptions}
        onChange={(e) => this.handleVideoCategorySelect(e)}
        value={this.state.videoCategoryOptions.find(
          (o) => o.value === String(this.state.selectedVideoCategory)
        )}
      />
    );
  };

  renderTabbedContent = () => {
    if (!this.state.dataFetched) {
      return null;
    }

    let filteredData = this.props.data.trainings;

    if (
      this.state.selectedServiceType !== null &&
      this.state.selectedServiceType !== "0"
    ) {
      filteredData = filteredData.filter((item) => {
        return (
          item.affectedByTrainingCode !== null &&
          item.affectedByTrainingCode.value ===
          parseInt(this.state.selectedServiceType)
        );
      });
    }

    if (
      this.state.selectedVideoCategory !== null &&
      this.state.selectedVideoCategory !== "0"
    ) {
      filteredData = filteredData.filter((item) => {
        return (
          item.videoCategory !== null &&
          item.videoCategory.id === this.state.selectedVideoCategory
        );
      });
    }

    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <InformationalVideos
          data={filteredData}
          employeeCode={this.props.data.employeeCode}
        />
      </div>
    );
  };

  render() {
    return (
      <section className="profilArea my-3">
        {this.props.spinner}
        <div className="container">
          <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <Trans desc="Eğitim ve Gelişim">10025</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Bilgilendirme Videoları">10058</Trans>
                </li>
              </ul>
            </div>
          </div>
          <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <div className="profilBaslik">
                <Trans desc="Bilgilendirme Videoları">10058</Trans>
              </div>
            </div>
          </div>

          <div className="row calculateArea">
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 my-1">
              <div className="ml-2">
                <label>
                  <Trans desc="Servis Tipi">10615</Trans>
                </label>
                {this.renderServiceTypeCombo()}
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 my-1">
              <div className="ml-2">
                <label>
                  <Trans desc="Kategori">10616</Trans>
                </label>
                {this.renderVideoCategoryCombo()}
              </div>
            </div>
          </div>

          <div className="row py-4 bottomRow">{this.renderTabbedContent()}</div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.informationalVideos.data,
  };
};

export default connect(mapStateToProps, {
  getInformationalVideos,
  getVideoCategories,
})(requireAuth(containsLongRunningProcess(InformationalVideosContainer)));
